import React, { useRef, useEffect } from 'react';
import { Container, Grid, Dropdown, Table } from 'semantic-ui-react';
import moment from 'moment-timezone';
import { AgGridReact } from '@ag-grid-community/react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { MapContainer, Popup, TileLayer, CircleMarker, Polyline } from 'react-leaflet';
import 'leaflet-polylinedecorator';
import toastr from 'toastr';
import * as _ from 'lodash';
import { ERRORS } from '../../../../HelperMethods/constants';
import apiService from '../../../../service/apiService';
import * as Utility from '../../../../HelperMethods/UtilityFunctions';
import * as DateUtils from '../../../../HelperMethods/DateUtils';
import logUtils from '../../../../HelperMethods/LogUtils';
import Joyn2Loader from '../../../common/Joyn2Loader';
import { GRID_OPTIONS } from '../../../../HelperMethods/AgGridConstants';

const gridStyle = {
  width: '100%',
  height: '500px',
};

/* eslint-disable */

const searchOptionsIsNumberMap = {
  score_cost_coefficient: true,
  high_score_threshold: true,
  high_score_cost_coefficient: true,
  time_limit_ms: true,
  high_score_multiplier: true,
  enable_clustering: false,
  enable_group_clustering: false,
  balance_tech_time_coefficient: true,
  enable_crow_fly: false,
  disable_hard_assignments: false,
  disable_tech_end_location: false,
  same_start_time_buffer: true,
};

const mapcolors = [
  '#ff7c8b',
  '#e800c6',
  '#34495e',
  '#d35400',
  '#1abc9c',
  '#ffb900',
  '#ee0080',
  '#ff8a62',
  '#ff8a95',
  '#f2b900',
];
const PolylineDecorator = ({ patterns, ...props }) => {
  const polyRef = useRef(null);
  const map = useMap();

  useEffect(() => {
    if (!polyRef.current) return;

    const polyline = polyRef.current;
    const polyLineDecorator = L.polylineDecorator(polyline, {
      patterns,
    }).addTo(map);

    return () => {
      map.removeLayer(polyLineDecorator);
    };
  }, [patterns, map]);

  return <Polyline ref={polyRef} {...props} />;
};

const CENTER_COORDS = [34.158782, -118.8323902];

class EngineSingleLogView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPageLoading: false,
      center: CENTER_COORDS,
      users: [],
      mapInput: [],
      routes: [],
      techRoutesSummary: [],
      taskTypesRoutesSummary: [],
      techsDict: {},
      all_total_service_time: 0,
      all_total_drive_time: 0,
      all_total_score: 0,
      objective_cost: 0,
      penalty_cost: 0,
      score_diff_cost: 0,
      balance_tech_time_dimension_cost: 0,
      balance_tech_shift_utilization_cost: 0,
      tech_fixed_cost: 0,
      high_score_cost_dimension_cost: 0,
      priority_mode_cost: 0,
      drive_time_cost: 0,
      gridOptions: {
        statusBar: {
          statusPanels: [
            {
              statusPanel: 'agTotalAndFilteredRowCountComponent',
              align: 'left',
            },
          ],
        },
      },
      autoGroupColumnDef: {
        cellRendererParams: {
          suppressCount: true,
        },
      },
      inputLogfileName: '',
      outputLogfileName: '',
      result: {
        score_diff_cost: 0,
        objective_cost: 0,
      },
    };
  }

  async componentDidMount() {
    const { logData } = this.props;
    const { id, data } = logData;
    const { pathToFile } = data;
    this.setState({ isPageLoading: true });
    try {
      const resp = await apiService.getEngineDebugData(id, pathToFile);
      this.setState({ isPageLoading: false });
      const { input, output } = Utility.inflateResponse(resp);
      this.inputLogfileHandler(input);
      this.outputLogfileHandler(output);
    } catch (e) {
      const message =
        e instanceof Error
          ? 'Api Failed'
          : e.message === ERRORS.DECOMPRESSION_INVALID_INPUT_ERROR
          ? 'Invalid Compressed Response'
          : e.message;
      logUtils.logError(e, message);
      this.setState({ isPageLoading: false });
    }
  }

  engineInputCoefficientHandler = (evt) => {
    const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
    const newState = { ...this.state };
    newState.input.search_options[evt.target.name] = value;
    this.setState(newState);
  };

  validateSearchOptions = () => {
    let valid = true;
    Object.entries(searchOptionsIsNumberMap).forEach(([key, value]) => {
      if (value) {
        valid = valid && !_.isNaN(parseFloat(this.state.input.search_options[key]));
      }
    });
    return valid;
  };

  handleEngineRerunClick = () => {
    if (!this.validateSearchOptions()) {
      return toastr.error('Invalid engine coefficients');
    }
    const newState = { ...this.state };
    Object.keys(searchOptionsIsNumberMap).forEach((key) => {
      if (searchOptionsIsNumberMap[key]) {
        const value = this.state.input.search_options[key];
        newState.input.search_options[key] = _.isNaN(parseFloat(value)) ? 0 : parseFloat(value);
      }
    });
    this.setState(newState);
    this.rerunEngine();
  };
  secondsToHms = (d) => {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? ' hour ' : ' hours ') : '';
    var mDisplay = m > 0 ? m + (m == 1 ? ' minute ' : ' minutes ') : '';
    var sDisplay = s > 0 ? s + (s == 1 ? ' second' : ' seconds') : '';
    return hDisplay + mDisplay + sDisplay;
  };

  formatPercentage = (numerator, denominator, toFixed = 2, text = '') => {
    return ((numerator / denominator) * 100).toFixed(toFixed) + '%' + (text ? ' of ' + text : '');
  };

  inputLogfileHandler = (input) => {
    let logfile = input;
    const logFileCopy = JSON.parse(JSON.stringify(logfile));
    this.setState({ minTimeZone: logfile.minTimeZone });
    const { names, latLngs, search_options } = logfile;
    if (search_options && search_options.balance_travel_time !== undefined) {
      search_options.balance_tech_time_coefficient = search_options.balance_travel_time ? 1 : 0;
      delete search_options.balance_travel_time;
    }
    // defaulting [null, null] lat longs to [0,0]
    Object.keys(latLngs || {}).forEach((e) => {
      if (!(latLngs[e] && latLngs[e][0] && latLngs[e][1])) {
        latLngs[e] = [0, 0];
      }
    });

    const tasksDict = {};
    const startEndLocsDict = {};
    // calculate centre based on lat lngs
    let bounds = Object.keys(latLngs)
      .map((e) => latLngs[e])
      .filter((e) => !(e[0] === 0 && e[1] === 0));
    this.setState({ bounds });
    // update tasks with latlng
    logfile.tasks.forEach((e, i) => {
      if (
        search_options &&
        search_options.high_score_threshold &&
        search_options.high_score_multiplier &&
        e.score > search_options.high_score_threshold
      ) {
        e.score /= search_options.high_score_multiplier;
      }
      names[e.id] = `T ${i + 1}`;
      e.latLng = latLngs[e.location_id] || 'notfound';
    });
    const tasksByStopsDict = {};
    logfile.tasks.forEach((e, i) => {
      if (e.depends_on && e.depends_on.length > 0) {
        e.depends_on = e.depends_on.map((t) => names[t] || 'notfound');
      }
      if (e.same_assignee_as) {
        e.same_assignee_as = names[e.same_assignee_as] || '';
      }
      if (e.immediate_next_to) {
        e.immediate_next_to = names[e.immediate_next_to] || '';
      }
      if (e.same_start_time_as && e.same_start_time_as.length > 0) {
        e.same_start_time_as = e.same_start_time_as.map((t) => names[t] || 'notfound');
      }
      tasksByStopsDict[e.location_id] = tasksByStopsDict[e.location_id] || [];
      tasksByStopsDict[e.location_id].push(e);
      tasksDict[e.id] = e;
    });
    const techsDict = {};
    // update techs with lat lng
    logfile.techs.forEach((e) => {
      startEndLocsDict[e.start_location_id] = 1;
      startEndLocsDict[e.end_location_id] = 1;
      e.start_location_latlng = latLngs[e.start_location_id] || 'notfound';
      e.end_location_latlng = latLngs[e.end_location_id] || 'notfound';
      techsDict[e.id] = e;
    });
    this.setState({ startEndLocsDict });
    logfile = this.handleDistanceMatrix(logfile, logfile.distance_matrix, names);
    // generate names for ID columns
    Object.keys(logfile).forEach((e) => {
      if (logfile[e].length && typeof logfile[e] !== 'string' && logfile[e].length > 0) {
        logfile[e].forEach((item) => {
          Object.keys(item).forEach((key) => {
            if (key.indexOf('_id') > 0 || key === 'assignee') {
              const newKey = key.replace('_id', '_name');
              if (item[key] instanceof Array) {
                if (key === 'assignee') {
                  item[newKey] = item[key].map((id) => names[id] || 'Assignee has invalid setup.');
                } else {
                  item[newKey] = item[key].map((id) => names[id]);
                }
              } else {
                item[newKey] = names[item[key]];
              }
            }
            if (key === 'id') {
              const newKey = `${e}:name`;
              item[newKey] = names[item[key]] || item[key];
              // if (e === "techs") {
              //   debugger;
              // item[newKey] = item[newKey].replace(/(@.*)/g, '');
              // }
            }
          });
        });
      }
    });
    const mapInput = [];
    Object.keys(latLngs).forEach((e) => {
      const tasksAtStop = tasksByStopsDict[e] || [];
      mapInput.push({
        id: e,
        name: names[e],
        latLng: latLngs[e] && latLngs[e][0] && latLngs[e][1] ? latLngs[e] : [0, 0],
        tasks: tasksAtStop,
      });
    });
    // proocess teams and areas mapping
    const { teams } = logfile;
    const teamOutput = [];
    teams.forEach((team) => {
      const { team_areas, id } = team;
      team_areas.forEach((e) => {
        const { area_id, primary, secondary } = e;
        teamOutput.push({
          team_name: names[id],
          area_name: names[area_id],
          primary: primary.map((e) => names[e]),
          secondary: secondary.map((e) => names[e]),
        });
      });
    });
    this.setState({
      input: logfile,
      teams: teamOutput,
      tasks: logfile.tasks,
      mapInput,
      techsDict,
      tasksDict,
      inputCopy: logFileCopy,
    });
  };

  rerunEngine = () => {
    const { data, id: requestId } = this.props.logData;
    const { pathToFile } = data;
    const searchOptions = this.state.input.search_options;
    this.setState({ isPageLoading: true });

    const mainFunction = () => {
      apiService
        .rerunEngine(requestId, pathToFile, searchOptions)
        .then((response) => {
          console.debug('response from run engine lambda');
          console.debug(response);
        })
        .catch((error) => {
          console.error(error);
        });
    };
    const timeoutPeriod = searchOptions.time_limit_ms * 2 > 120000 ? searchOptions.time_limit_ms * 2 : 120000; // min timeout period is 2 mins
    Utility.subscribeFunction(
      apiService.onUpdateRequestId,
      requestId,
      mainFunction,
      timeoutPeriod,
      async (response) => {
        try {
          const res = response.value.data.onUpdateRequestId;
          if (!res.success) {
            throw res;
          }
          const resp = await apiService.getEngineDebugData(requestId, pathToFile, true);
          this.setState({ isPageLoading: false });

          const { output } = Utility.inflateResponse(resp);
          this.outputLogfileHandler(output);
        } catch (e) {
          const message =
            e instanceof Error
              ? 'Run Engine Failed'
              : e.message === ERRORS.DECOMPRESSION_INVALID_INPUT_ERROR
              ? 'No output received'
              : e.message;
          logUtils.logError(e, message);
          this.setState({ isPageLoading: false });
        }
      },
      (error) => {
        const message = error instanceof Error ? 'Run Engine Failed' : error.message;
        logUtils.logError(error, message);
        this.setState({ isPageLoading: false });
      }
    );
  };

  outputLogfileHandler = (output) => {
    const logfile = output;
    const payload = JSON.parse(logfile.Payload);
    Object.keys(this.state.tasksDict).forEach((e) => {
      this.state.tasksDict[e].engine_assigned = false;
    });
    // debugger;
    const { distance_matrix: distanceMatrix, names } = logfile;
    const { raw_result: result, routes } = payload;
    let routesUpdated = [];
    let techRoutesSummary = [];
    const techRoutesShiftSummary = [];
    let taskTypesCompletedSummaryAllTechs = {};
    const taskTypesInfo = {};
    const stopsInfo = {};
    const list = [];
    const mapOutput = [];
    let routesCount = 0;
    const visitsBoundsLatLang = [];

    let all_total_service_time = 0;
    let all_total_drive_time = 0;
    let all_total_score = 0;
    const { objective_cost } = result;
    const { penalty_cost } = result;
    const { score_diff_cost } = result;
    const { balance_tech_time_dimension_cost, balance_tech_shift_utilization_cost = 0, tech_fixed_cost = 0 } = result;
    const { high_score_cost_dimension_cost, priority_mode_cost = 0 } = result;
    const { drive_time_cost } = result;
    const users = [];
    const taskTypeTeamMap = {};

    for (const { id, team_id } of this.state.inputCopy.task_types) {
      taskTypeTeamMap[id] = team_id;
    }

    for (const task of this.state.inputCopy.tasks) {
      const { task_type_id, location_id } = task;

      taskTypesInfo[task_type_id] = taskTypesInfo[task_type_id] || {
        counter: 0,
        pickedCounter: 0,
        serviceTimeCompleted: 0,
      };

      taskTypesInfo[task_type_id].counter += 1;
      stopsInfo[location_id] = stopsInfo[location_id] || { counter: 0, pickedCounter: 0, serviceTimeCompleted: 0 };
      stopsInfo[location_id].counter += 1;
      stopsInfo[location_id][task_type_id] = stopsInfo[location_id][task_type_id] || {
        counter: 0,
        pickedCounter: 0,
        serviceTimeCompleted: 0,
      };
      stopsInfo[location_id][task_type_id].counter += 1;
    }
    routes.forEach((e) => {
      const { tech_id, visits } = e;
      if (visits.length === 0) {
        // list.push({
        //   tech_id
        // });
      } else {
        let total_service_time = 0;
        let total_drive_time = 0;
        let total_score = 0;
        const intialCount = routesUpdated.length;

        const techObject = this.state.techsDict[tech_id] || {
          start_location_latlng: CENTER_COORDS,
          end_location_latlng: CENTER_COORDS,
        };
        users.push({
          key: techObject['techs:name'],
          value: techObject['techs:name'],
          text: techObject['techs:name'],
        });

        const startLocLatLng = techObject.start_location_latlng;
        // poly line
        const visitsLatLng = [];
        if (startLocLatLng instanceof Array) {
          visitsLatLng.push(startLocLatLng);
          visitsBoundsLatLang.push(startLocLatLng);
        } else {
          console.log(techObject);
        }
        // add start Location
        const firstVisit = this.state.tasksDict[visits[0].task_id].location_id;
        const user_location = techObject.start_location_id;
        // debugger;
        const traveltime = Math.round(this.state.input.distance_matrix[user_location][firstVisit].travel_time);
        // wait_time: 0,
        const startToFirstTask = {
          tech_id,
          task_name: ' ',
          score: ' ',
          task_type_name: '',
          service_time: 0,
          arrive_time: 0,
          depart_time: visits[0].arrive_time - traveltime,
          travel_time_to_next_node: traveltime,
          color: mapcolors[routesCount % mapcolors.length],
          asset_name: this.state.input.names[user_location],
          location_name: this.state.input.names[user_location],
          location_group_name: '',
        };
        total_drive_time += traveltime;
        routesUpdated.push(startToFirstTask);
        visits.forEach((item) => {
          // debugger;
          const task = this.state.tasksDict[item.task_id] || {};
          const { task_type_id, task_type_name, location_id } = task;

          taskTypesInfo[task_type_id][tech_id] = taskTypesInfo[task_type_id][tech_id] || {
            serviceTimeCompletedByTech: 0,
            pickedCounter: 0,
          };

          stopsInfo[location_id][task_type_id][tech_id] = stopsInfo[location_id][task_type_id][tech_id] || {
            pickedCounter: 0,
            serviceTimeCompletedByTech: 0,
          };
          task.engine_assigned = true;
          // add only if the location does not exist.
          if (JSON.stringify(task.latLng) !== JSON.stringify(visitsLatLng[visitsLatLng.length - 1])) {
            if (task.latLng instanceof Array && task.latLng[0] !== 0 && task.latLng[1] !== 0) {
              visitsLatLng.push(task.latLng);
            }
          }
          if (task.latLng instanceof Array) {
            visitsBoundsLatLang.push(task.latLng);
          }
          // debugger;
          total_drive_time += item.travel_time_to_next_node;
          total_service_time += item.service_time;
          total_score += parseInt(task.score || '0');
          item.score = task.score;
          item.tech_id = tech_id;
          item.color = mapcolors[routesCount % mapcolors.length];
          item.asset_name = task.asset_name;
          item.location_name = task.location_name;
          item.location_group_name = task.location_group_name;
          item.task_type_name = task_type_name;
          routesUpdated.push(item);
          taskTypesInfo[task_type_id].serviceTimeCompleted += task.service_time;
          taskTypesInfo[task_type_id].pickedCounter += 1;
          taskTypesInfo[task_type_id][tech_id].serviceTimeCompletedByTech += task.service_time;
          taskTypesInfo[task_type_id][tech_id].pickedCounter += 1;

          stopsInfo[location_id].pickedCounter += 1;
          stopsInfo[location_id][task_type_id].pickedCounter += 1;
          stopsInfo[location_id][task_type_id][tech_id].pickedCounter += 1;

          stopsInfo[location_id].serviceTimeCompleted += 1;
          stopsInfo[location_id][task_type_id].serviceTimeCompleted += 1;
          stopsInfo[location_id][task_type_id][tech_id].serviceTimeCompletedByTech += 1;
        });

        const disableTechEndLocation =
          String(this.state.input.search_options.disable_tech_end_location || 'false') === 'true';

        const lastVisit = this.state.tasksDict[visits[visits.length - 1].task_id].location_id;
        const user_end_location = disableTechEndLocation ? lastVisit : techObject.end_location_id;

        const traveltimeEnd = this.state.input.distance_matrix[user_end_location][lastVisit].travel_time;
        const endoftasks = {
          tech_id,
          color: mapcolors[routesCount % mapcolors.length],
          asset_name: this.state.input.names[user_end_location],
          location_name: this.state.input.names[user_end_location],
          travel_time_to_next_node: total_drive_time,
          service_time: total_service_time,
          arrive_time: visits[visits.length - 1].depart_time + traveltimeEnd,
          depart_time: 0,
          task_name: 'Totals',
          task_type_name: '',
          score: '-',
        };
        routesUpdated.push(endoftasks);
        const color = mapcolors[routesCount % mapcolors.length];
        routesCount += 1;
        const endStopLatLng = techObject.end_location_latlng;
        if (
          endStopLatLng instanceof Array &&
          JSON.stringify(endStopLatLng) !== JSON.stringify(visitsLatLng[visitsLatLng.length - 1]) &&
          !disableTechEndLocation
        ) {
          visitsLatLng.push(endStopLatLng);
        }

        if (endStopLatLng instanceof Array) {
          visitsBoundsLatLang.push(endStopLatLng);
        } else {
          console.log(techObject);
        }

        const finalCount = routesUpdated.length;
        const currentRoute = routesUpdated.slice(intialCount, finalCount);
        mapOutput.push({ color, techObject, visitsLatLng, currentRoute });
        all_total_service_time += total_service_time;
        all_total_drive_time += total_drive_time;
        all_total_score += total_score;

        const time_spent_by_tech = endoftasks.arrive_time - techObject.start_time;
        techRoutesShiftSummary.push({
          tech_info: [
            {
              tech_id: tech_id,
              info: 'Travelling',
              percentage_wrt_shift: this.formatPercentage(
                endoftasks.travel_time_to_next_node,
                time_spent_by_tech,
                2,
                'utilized shift spent on'
              ),
              percentage_wrt_others: '-',
              duration: this.secondsToHms(endoftasks.travel_time_to_next_node),
              team: '-',
              highlightRow: true,
              highlightRowColor: 'lightYellow',
              // total: '-',
              // got_picked: '-',
              // picked_by_this_tech: '-',
              // percentage_picked: '-',
            },
            {
              tech_id: tech_id,
              info: 'Shift Utilization Summary',
              percentage_wrt_shift: this.formatPercentage(
                time_spent_by_tech,
                techObject.max_time - techObject.start_time,
                2,
                'shift is utilized'
              ),
              percentage_wrt_others: '-',
              duration: this.secondsToHms(endoftasks.arrive_time - techObject.start_time),
              time_left: this.secondsToHms(techObject.max_time - endoftasks.arrive_time),
              team: '-',
              highlightRow: true,
              highlightRowColor: 'lightYellow',
              // total: '-',
              // got_picked: '-',
              // picked_by_this_tech: '-',
              // percentage_picked: '-',
            },
          ],
          tech_id,
          time_spent_by_tech,
        });
      }
    });

    const taskTypesRoutesSummary = [];

    for (const task_type_id in taskTypesInfo) {
      const totalTasks = taskTypesInfo[task_type_id].counter;
      let totalPicked = 0;
      if (taskTypesInfo[task_type_id].pickedCounter) {
        totalPicked = taskTypesInfo[task_type_id].pickedCounter;

        for (const tech_id in taskTypesInfo[task_type_id]) {
          if (this.state.techsDict[tech_id]) {
            taskTypesRoutesSummary.push({
              task_type_id,
              user: this.state.input.names[tech_id],
              assigned: taskTypesInfo[task_type_id][tech_id].pickedCounter,
              assigned_percentage: this.formatPercentage(
                taskTypesInfo[task_type_id][tech_id].pickedCounter,
                totalPicked,
                2,
                'the done is by'
              ),
              total: '-',
            });
          }
        }
      }
      taskTypesRoutesSummary.push({
        task_type_id,
        user: 'Summary',
        assigned: totalPicked,
        assigned_percentage: this.formatPercentage(totalPicked, totalTasks, 2, 'the total are picked'),
        total: totalTasks,
        highlightRow: true,
        highlightRowColor: 'lightyellow',
      });
    }

    for (const tech of techRoutesShiftSummary) {
      const { tech_id, tech_info, time_spent_by_tech } = tech;
      for (const taskTypeId in taskTypesInfo) {
        if (taskTypesInfo[taskTypeId][tech_id]) {
          techRoutesSummary.push({
            tech_id: tech_id,
            info: this.state.input.names[taskTypeId],
            percentage_wrt_shift: this.formatPercentage(
              taskTypesInfo[taskTypeId][tech_id].serviceTimeCompletedByTech,
              time_spent_by_tech,
              2,
              'utilized shift spent on'
            ),
            duration: this.secondsToHms(taskTypesInfo[taskTypeId][tech_id].serviceTimeCompletedByTech),
            team: this.state.input.names[taskTypeTeamMap[taskTypeId]],
            // total: taskTypesInfo[taskTypeId].totalCounter,
            // got_picked: taskTypesInfo[taskTypeId].pickedCounter,
            // percentage_picked: this.formatPercentage(
            //   taskTypesInfo[taskTypeId].pickedCounter,
            //   taskTypesInfo[taskTypeId].totalCounter
            // ),
            // picked_by_this_tech: taskTypesInfo[taskTypeId][tech_id].pickedCounter,
            // percentage_wrt_others: this.formatPercentage(
            //   taskTypesInfo[taskTypeId][tech_id].serviceTimeCompletedByTech,
            //   taskTypesInfo[taskTypeId].serviceTimeCompleted,
            //   2,
            //   'picked is done by'
            // ),
          });
        }
      }
      techRoutesSummary = techRoutesSummary.concat(tech_info);
    }

    const stopsDetailedSummary = [];
    const skippedTasksSummary = this.getSkippedTasksSummary(techRoutesShiftSummary);

    for (const stop_id in stopsInfo) {
      const teams_utilized_at_stop = {};
      for (const task_type_id in stopsInfo[stop_id]) {
        if (taskTypesInfo[task_type_id]) {
          teams_utilized_at_stop[taskTypeTeamMap[task_type_id]] =
            teams_utilized_at_stop[taskTypeTeamMap[task_type_id]] || [];
          let picked_by = '';
          for (const tech_id in stopsInfo[stop_id][task_type_id]) {
            if (this.state.techsDict[tech_id]) {
              picked_by +=
                `${this.state.input.names[tech_id]} (${stopsInfo[stop_id][task_type_id][tech_id].pickedCounter})` +
                ' | ';
              if (teams_utilized_at_stop[taskTypeTeamMap[task_type_id]].indexOf(tech_id) === -1) {
                teams_utilized_at_stop[taskTypeTeamMap[task_type_id]].push(tech_id);
              }
            }
          }
          stopsDetailedSummary.push({
            stop_id,
            task_type_name: this.state.input.names[task_type_id],
            team_name: this.state.input.names[taskTypeTeamMap[task_type_id]],
            assigned: stopsInfo[stop_id][task_type_id].pickedCounter,
            total: stopsInfo[stop_id][task_type_id].counter,
            assigned_percentage: this.formatPercentage(
              stopsInfo[stop_id][task_type_id].pickedCounter,
              stopsInfo[stop_id][task_type_id].counter,
              2,
              'the total are picked'
            ),
            assigned_to: picked_by,
            // color :''
          });
        }
      }
      let two_people_from_same_team_info = [];
      for (const team_id in teams_utilized_at_stop) {
        if (teams_utilized_at_stop[team_id].length > 1) {
          const text = `${teams_utilized_at_stop[team_id].length} (
              ${teams_utilized_at_stop[team_id]
                .map((tech_id) => this.state.input.names[tech_id])
                .join(', ')}) users from team ${this.state.input.names[team_id]}`;
          two_people_from_same_team_info.push(text);
        }
      }
      stopsDetailedSummary.push({
        stop_id,
        task_type_name: 'Summary',
        team_name: '-',
        assigned: stopsInfo[stop_id].pickedCounter,
        total: stopsInfo[stop_id].counter,
        assigned_percentage: this.formatPercentage(
          stopsInfo[stop_id].pickedCounter,
          stopsInfo[stop_id].counter,
          2,
          'the total are picked'
        ),
        assigned_to: `${two_people_from_same_team_info.length ? two_people_from_same_team_info.join('| ') : '-'}`,
        highlightRow: true,
        highlightRowColor: `${two_people_from_same_team_info.length ? 'lightcoral' : 'lightYellow'}`,
        // color : `${two_people_from_same_team_info.length > 1 ? 'red' : ''}`
      });
    }

    const taskTypesPicked = Object.keys(taskTypesInfo).filter(
      (task_type_id) => taskTypesInfo[task_type_id].pickedCounter
    );
    const teamsUtilizedMap = {};
    this.state.input.task_types.forEach((item) => {
      if (taskTypesPicked.indexOf(item.id) > -1) {
        const { team_name } = item;
        teamsUtilizedMap[team_name] = 1;
      }
    });

    const teamsUtilizedOptions = Object.keys(teamsUtilizedMap).map((item) => {
      return {
        key: item,
        value: item,
        text: item,
      };
    });

    this.setState({
      all_total_service_time: Math.round(all_total_service_time / 60),
      all_total_drive_time: Math.round(all_total_drive_time / 60),
      all_total_score,
      objective_cost,
      penalty_cost,
      score_diff_cost,
      balance_tech_time_dimension_cost,
      balance_tech_shift_utilization_cost,
      tech_fixed_cost,
      high_score_cost_dimension_cost,
      priority_mode_cost,
      drive_time_cost,
    });
    routesUpdated = [].concat(routesUpdated, list);
    // generate names for ID columns
    routesUpdated.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (key.indexOf('_id') > 0) {
          const newKey = key.replace('_id', '_name');
          item[newKey] = this.state.input.names[item[key]] || item[key];
        }
      });
    });
    techRoutesSummary.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (key.indexOf('_id') > 0) {
          const newKey = key.replace('_id', '_name');
          item[newKey] = this.state.input.names[item[key]] || item[key];
        }
      });
    });
    taskTypesRoutesSummary.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (key.indexOf('_id') > 0) {
          const newKey = key.replace('_id', '_name');
          item[newKey] = this.state.input.names[item[key]] || item[key];
        }
      });
    });
    stopsDetailedSummary.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (key.indexOf('_id') > 0) {
          const newKey = key.replace('_id', '_name');
          item[newKey] = this.state.input.names[item[key]] || item[key];
        }
      });
    });
    if (distanceMatrix) {
      let input = _.clone(this.state.input);
      input = this.handleDistanceMatrix(input, distanceMatrix, names);
      this.setState({ input });
    }
    this.setState({
      routes: routesUpdated,
      mapOutput,
      newmapOutput: mapOutput,
      result,
      users,
      teamsUtilizedOptions,
      bounds: visitsBoundsLatLang && visitsBoundsLatLang.length ? visitsBoundsLatLang : this.state.bounds,
      tasks: this.state.tasks,
      techRoutesSummary: techRoutesSummary,
      taskTypesRoutesSummary,
      stopsDetailedSummary,
      skippedTasksSummary,
    });
  };

  handleDistanceMatrix = (input, distanceMatrix, names) => {
    input.distanceMatrix = [];
    Object.keys(distanceMatrix).forEach((e) => {
      if (names[e]) {
        const out = {
          stop: names[e].replace(/\./gm, ''),
        };
        Object.keys(distanceMatrix[e]).forEach((it) => {
          // debugger;
          if (names[it]) {
            const stopName = names[it].replace(/\./gm, '');
            // const stopName2 = names[e];
            let travelTime = parseFloat((distanceMatrix[e][it].travel_time / 60).toPrecision(3));
            if (e !== it && (isNaN(travelTime) || travelTime === 0)) {
              travelTime = '0';
            }
            out[stopName] = travelTime;
          }
        });
        // debugger;
        input.distanceMatrix.push(out);
      }
    });
    return input;
  };
  getUsersWhoCanBeAssignedForTeams = (team_names) => {
    let user_names_for_teams = {};
    this.state.teams.forEach((team) => {
      const { team_name, primary = [], secondary = [] } = team;
      if (team_names.indexOf(team_name) > -1) {
        let users = [];
        if (primary.length) {
          users = primary;
        } else if (secondary.length) {
          users = secondary;
        }
        users.forEach((user_name) => {
          user_names_for_teams[user_name] = 1;
        });
      }
    });
    return user_names_for_teams;
  };

  filterPotentialTechsOnSkillsCertificatesNeeded = (task, potentialTechIds, techCertificatesSkillLevelMap) => {
    const { task_types } = this.state.input;

    const taskType = task_types.filter((item) => item.id === task.task_type_id)[0];

    const certificatesNeeded = taskType.certificates || [];
    const skillLevelNeeded = taskType.skill_level;

    if (!certificatesNeeded.length && !skillLevelNeeded) {
      return potentialTechIds;
    }

    let filteredPotentialTechs = [];

    for (const techId of potentialTechIds) {
      let certified = false;
      let hasSkillLevel = false;
      const mapping = techCertificatesSkillLevelMap[techId];
      const techCertificates = mapping.certificates;
      const techSkillLevel = mapping.skillLevel;
      const techCertificatesMap = {};

      for (const certificateHasId of techCertificates) {
        techCertificatesMap[certificateHasId] = 1;
      }

      if (!certificatesNeeded.length) {
        certified = true;
      } else {
        certified = true;
        for (const certificateNeededId of certificatesNeeded) {
          if (!techCertificatesMap[certificateNeededId]) {
            certified = false;
          }
        }
      }

      if (!skillLevelNeeded) {
        hasSkillLevel = true;
      } else {
        if (techSkillLevel && techSkillLevel >= skillLevelNeeded) {
          hasSkillLevel = true;
        }
      }

      if (certified && hasSkillLevel) {
        filteredPotentialTechs.push(techId);
      }
    }

    return filteredPotentialTechs;
  };

  findPotentialTechsForTask = (task) => {
    const { inputCopy } = this.state;
    const { task_types, areas, teams, techs } = inputCopy;
    const { task_type_id, location_id } = task;

    let potentialTechs = [];

    if (task['assignee'] && task['assignee'].length) {
      potentialTechs = task.assignee;
      return potentialTechs;
    }

    const taskType = task_types.filter((item) => item.id === task_type_id)[0];
    const team = teams.filter((item) => item.id === taskType.team_id)[0];
    for (const teamArea of team.team_areas) {
      const area = areas.filter((item) => item.id === teamArea.area_id)[0];
      const { location_ids } = area;
      if (location_ids.indexOf(location_id) > -1) {
        potentialTechs = [...potentialTechs, ...teamArea.primary];
        let primaryTechsMaxTime = 0;
        for (const { id, max_time } of techs) {
          if (teamArea.primary.indexOf(id) > -1) {
            primaryTechsMaxTime += max_time;
          }
        }
        if (primaryTechsMaxTime <= 0) {
          potentialTechs = [...potentialTechs, ...teamArea.secondary];
        }
      }
    }

    return potentialTechs;
  };

  getTasksPotentialTechsMap = () => {
    const tasksPotentialAssigneeMap = {};
    const techCertificatesSkillLevelMap = {};

    for (const { id, certificates = [], skill_level } of this.state.inputCopy.techs) {
      if (id) {
        techCertificatesSkillLevelMap[id] = {};
        techCertificatesSkillLevelMap[id].certificates = certificates;
        techCertificatesSkillLevelMap[id].skillLevel = skill_level;
      }
    }

    for (const task of this.state.inputCopy.tasks) {
      // determine potential techs for a task
      let potentialTechIds = this.findPotentialTechsForTask(task);

      // filter techs who are not part of the input
      potentialTechIds = potentialTechIds.filter((id) => techCertificatesSkillLevelMap[id]);

      // filter potentialTechIds on certificates and skill_level for the task type
      potentialTechIds = this.filterPotentialTechsOnSkillsCertificatesNeeded(
        task,
        potentialTechIds,
        techCertificatesSkillLevelMap
      );

      const excludeTechIds = task['exclude_assignee'];

      if (excludeTechIds) {
        potentialTechIds = potentialTechIds.filter((id) => excludeTechIds.indexOf(id) === -1);
      }

      tasksPotentialAssigneeMap[task.id] = potentialTechIds;
    }

    return tasksPotentialAssigneeMap;
  };

  getSkippedTasksSummary = (techRoutesShiftSummary) => {
    const skippedTasksSummary = [];
    const tasksPotentialTechsMap = this.getTasksPotentialTechsMap();
    const { names, tasks, techs } = this.state.inputCopy;
    const techRoutesTimeLeftMap = {};
    for (const tech of techRoutesShiftSummary) {
      const { tech_info, tech_id } = tech;
      techRoutesTimeLeftMap[tech_id] = tech_info[1].time_left;
    }
    const leftOutTechsTimeLeftMap = {};
    for (const tech of techs) {
      const { max_time, start_time, id } = tech;
      if (!techRoutesTimeLeftMap[id]) {
        leftOutTechsTimeLeftMap[id] = this.secondsToHms(max_time - start_time);
      }
    }

    for (const task of tasks) {
      if (!this.state.tasksDict[task.id].engine_assigned) {
        skippedTasksSummary.push({
          task_number: this.state.tasksDict[task.id]['tasks:name'],
          task_type_name: names[task.task_type_id],
          original_assignee:
            (this.state.tasksDict[task.id]['assignee'] || []).map((name) => name || '').join(', ') || '-',
          potential_assignee:
            (tasksPotentialTechsMap[task.id] || [])
              .map((id) => {
                if (names[id]) {
                  if (techRoutesTimeLeftMap[id]) {
                    return `${names[id]} (remaining ${techRoutesTimeLeftMap[id]})`;
                  } else {
                    return leftOutTechsTimeLeftMap[id]
                      ? `${names[id]} (remaining ${leftOutTechsTimeLeftMap[id]})`
                      : 'Assignee not in the shift';
                  }
                } else {
                  return 'Assignee has invalid setup.';
                }
              })
              .join(', ') || '-',
          duration: this.secondsToHms(task.service_time),
          score: task.score,
          location: names[task.location_id],
        });
      }
    }
    return skippedTasksSummary;
  };

  handleFilterUser = (event, { value }) => {
    // debugger;
    this.setState({ selectedUsers: value, newmapOutput: [], selectedTeams: [] });
    if (value.length === 0) {
      this.setState({ newmapOutput: this.state.mapOutput });
    } else {
      const newmapOutput = this.state.mapOutput.filter((e) => {
        const tech = e.techObject['techs:name'];
        if (value.length > 0 && value.indexOf(tech) > -1) {
          return true;
        }
        return false;
      });
      this.setState({ newmapOutput });
    }
  };

  handleFilterTeam = (event, { value }) => {
    this.setState({ selectedTeams: value, newmapOutput: [], selectedUsers: [] });
    if (value.length === 0) {
      this.setState({ newmapOutput: this.state.mapOutput });
    } else {
      const user_names_for_teams = this.getUsersWhoCanBeAssignedForTeams(value);
      const newmapOutput = this.state.mapOutput.filter((e) => {
        const tech = e.techObject['techs:name'];
        if (user_names_for_teams[tech]) {
          return true;
        }
        return false;
      });
      this.setState({ newmapOutput, selectedUsers: Object.keys(user_names_for_teams) });
    }
  };

  onGridReady = (params, fitColumns = true) => {
    if (fitColumns) {
      params.api.sizeColumnsToFit();
    }
    params.api.expandAll();
    // params.api.collapseAll();
  };

  getRowStyle = (params) => {
    // debugger;
    if (params.data && params.data.highlightRow) {
      return { 'background-color': params.data.highlightRowColor };
    }
    return null;
  };

  getColumnDefs = (inputArray, group, dms = false, pivot, tasksInput = false) => {
    // debugger;
    const isHidden = (group, e) => {
      if (group === e || e === 'id' || e.indexOf('_id') > 0) {
        return true;
      }
      return false;
    };
    // debugger;
    return inputArray
      .map((e) => {
        const out = {
          headerName: e,
          field: e,
          resizable: true,
          sortable: true,
          filter: true,
          rowGroup: group === e,
          hide: isHidden(group, e),
          pivot: !!(pivot && pivot.indexOf(e) > -1),
        };
        if (e.indexOf(':') > 0 || e === 'stop') {
          out.pinned = 'left';
        }
        if (e === 'color') {
          out.cellStyle = (params) => {
            if (params.value) {
              return { color: params.value, backgroundColor: params.value };
            }
            return null;
          };
        }
        if (dms === true) {
          out.cellStyle = (params) => {
            if (params.value === '0' || params.value === 120) {
              // mark wrong valued cells as red--> missing values
              return { color: 'white', backgroundColor: 'lightcoral' };
            }
            if (typeof params.value === 'number' && (params.value >= 60 || (params.value < 2 && params.value !== 0))) {
              // highlight values which can have
              return { color: 'purple', backgroundColor: 'white' };
            }
            return null;
          };
        }
        if (tasksInput && e === 'engine_assigned') {
          return null;
          // below code not working as of now
          out.cellStyle = (params) => {
            if (!params.value) {
              return { color: 'white', backgroundColor: 'red' };
            }
            return null;
          };
        }
        if (e === 'arrive_time' || e === 'depart_time' || e === 'start_time' || e === 'max_time') {
          out.cellRenderer = (params) => {
            if (params && params.value && params.value !== 0 && this.state.minTimeZone) {
              return moment.tz(this.state.minTimeZone).startOf('day').add(params.value, 'seconds').format('hh:mm a z');
            }
            return params.value;
          };
        }
        if (e === 'service_time') {
          out.cellRenderer = (params) => {
            if (params && params.value && typeof params.value === 'number') {
              return Math.round(params.value / 60);
            }
            return params.value;
          };
        }
        if (e === 'travel_time_to_next_node') {
          out.cellRenderer = (params) => {
            if (params && params.value && typeof params.value === 'number' && params.value !== 0) {
              return parseFloat((params.value / 60).toPrecision(3));
            }
            return params.value;
          };
        }
        return out;
      })
      .filter((item) => item);
  };

  render() {
    const { logData } = this.props;
    const { isPageLoading } = this.state;
    return (
      <Container
        fluid
        style={{
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
        className="container-above-task-view-grid"
      >
        {isPageLoading && <Joyn2Loader />}
        <div className="form-header">
          {logData.createdBy} {'at '}
          {DateUtils.convertUTCDateStringToYYYYMMDDHHMMSSFormat(logData.createdOn)}
          <div style={{ position: 'absolute', right: '40px', top: '13px' }}>
            <i
              onClick={() => {
                this.props.goBack();
              }}
              style={{ fontSize: '22px', cursor: 'pointer' }}
              className="fa fa-times-circle"
            />
          </div>
        </div>
        <Grid style={{ marginTop: '0px', height: 'calc(100% - 48px)' }}>
          <Grid.Row>
            <Grid.Column>
              {!!this.state.input && (
                <Grid>
                  <Grid.Row columns={4}>
                    <Grid.Column>
                      <h2>Total Time KPI </h2>
                      <Table striped selectable>
                        <Table.Body>
                          {/* <Table.Row>
                            <Table.Cell className="engine-log-view-table-header-cell">
                              Total Score of tasks Sequenced
                            </Table.Cell>
                            <Table.Cell>{this.state.all_total_score}</Table.Cell>
                          </Table.Row> */}
                          {!!this.state.tasks && this.state.tasks.length && (
                            <Table.Row>
                              <Table.Cell className="engine-log-view-table-header-cell">
                                Total Number of Tasks Assigned
                              </Table.Cell>
                              <Table.Cell>{this.state.tasks.filter((item) => item.engine_assigned).length}</Table.Cell>
                            </Table.Row>
                          )}
                          {!!this.state.tasks && this.state.tasks.length && (
                            <Table.Row>
                              <Table.Cell className="engine-log-view-table-header-cell">
                                Total number of tasks skipped
                              </Table.Cell>
                              <Table.Cell>{this.state.tasks.filter((item) => !item.engine_assigned).length}</Table.Cell>
                            </Table.Row>
                          )}
                          <Table.Row>
                            <Table.Cell className="engine-log-view-table-header-cell">
                              Total Service time (minutes)
                            </Table.Cell>
                            <Table.Cell>{this.state.all_total_service_time}</Table.Cell>
                          </Table.Row>
                          <Table.Row>
                            <Table.Cell className="engine-log-view-table-header-cell">
                              Total Drive time (minutes)
                            </Table.Cell>
                            <Table.Cell>{this.state.all_total_drive_time}</Table.Cell>
                          </Table.Row>
                        </Table.Body>
                      </Table>
                      {!!this.state.minTimeZone && <div> Refrence Time Zone: {this.state.minTimeZone}</div>}
                    </Grid.Column>
                    <Grid.Column>
                      <h2>Total Cost KPI </h2>
                      <Table striped selectable>
                        <thead />
                        <Table.Body>
                          <Table.Row>
                            <Table.Cell className="engine-log-view-table-header-cell">
                              Cost due to Drive Time
                            </Table.Cell>
                            <Table.Cell className="right-align-column">{this.state.drive_time_cost}</Table.Cell>
                          </Table.Row>
                          <Table.Row>
                            <Table.Cell className="engine-log-view-table-header-cell">
                              Cost due to Uphill Travel
                            </Table.Cell>
                            <Table.Cell className="right-align-column">{this.state.score_diff_cost}</Table.Cell>
                          </Table.Row>
                          <Table.Row>
                            <Table.Cell className="engine-log-view-table-header-cell">
                              Cost due to High Score Threshold
                            </Table.Cell>
                            <Table.Cell className="right-align-column">
                              {this.state.high_score_cost_dimension_cost}
                            </Table.Cell>
                          </Table.Row>
                          <Table.Row>
                            <Table.Cell className="engine-log-view-table-header-cell">
                              Cost due to Priority Mode
                            </Table.Cell>
                            <Table.Cell className="right-align-column">{this.state.priority_mode_cost}</Table.Cell>
                          </Table.Row>
                          <Table.Row>
                            <Table.Cell className="engine-log-view-table-header-cell">
                              Cost due to Tech Shift Utilization Balance
                            </Table.Cell>
                            <Table.Cell className="right-align-column">
                              {this.state.balance_tech_shift_utilization_cost}
                            </Table.Cell>
                          </Table.Row>
                          <Table.Row>
                            <Table.Cell className="engine-log-view-table-header-cell">
                              Cost due to Tasks Assigned techs who are Later in the Shift
                            </Table.Cell>
                            <Table.Cell className="right-align-column">{this.state.tech_fixed_cost}</Table.Cell>
                          </Table.Row>
                          {/* <Table.Row>
                            <Table.Cell className="engine-log-view-table-header-cell">
                              Cost due to Tech Time Balance
                            </Table.Cell>
                            <Table.Cell className="right-align-column">
                              {this.state.balance_tech_time_dimension_cost}
                            </Table.Cell>
                          </Table.Row> */}
                          <Table.Row>
                            <Table.Cell className="engine-log-view-table-header-cell">
                              Cost due to Skipping Tasks
                            </Table.Cell>
                            <Table.Cell className="right-align-column">{this.state.penalty_cost}</Table.Cell>
                          </Table.Row>
                          <Table.Row>
                            <Table.Cell className="engine-log-view-table-header-cell">Total Objective Cost</Table.Cell>
                            <Table.Cell className="right-align-column">{this.state.objective_cost}</Table.Cell>
                          </Table.Row>
                        </Table.Body>
                      </Table>
                    </Grid.Column>
                    <Grid.Column>
                      <h2>Engine Input Coefficients </h2>
                      <form onSubmit={() => {}}>
                        <Table striped selectable>
                          <Table.Body>
                            <Table.Row>
                              <Table.Cell className="engine-log-view-table-header-cell">
                                Score cost coefficient
                              </Table.Cell>
                              <Table.Cell className="engine-log-view-table-input-wrapper">
                                {!!this.state.input && !!this.state.input.search_options && (
                                  <input
                                    type="text"
                                    name="score_cost_coefficient"
                                    onChange={this.engineInputCoefficientHandler}
                                    className="engine-log-view-input-text-cell"
                                    value={this.state.input.search_options.score_cost_coefficient}
                                  />
                                )}
                              </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell className="engine-log-view-table-header-cell">
                                High score threshold
                              </Table.Cell>
                              <Table.Cell className="engine-log-view-table-input-wrapper">
                                {!!this.state.input && !!this.state.input.search_options && (
                                  <input
                                    type="text"
                                    name="high_score_threshold"
                                    onChange={this.engineInputCoefficientHandler}
                                    className="engine-log-view-input-text-cell"
                                    value={this.state.input.search_options.high_score_threshold}
                                  />
                                )}
                              </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell className="engine-log-view-table-header-cell">
                                High score cost coefficient
                              </Table.Cell>
                              <Table.Cell className="engine-log-view-table-input-wrapper">
                                {!!this.state.input && !!this.state.input.search_options && (
                                  <input
                                    type="text"
                                    name="high_score_cost_coefficient"
                                    onChange={this.engineInputCoefficientHandler}
                                    className="engine-log-view-input-text-cell"
                                    value={this.state.input.search_options.high_score_cost_coefficient}
                                  />
                                )}
                              </Table.Cell>
                            </Table.Row>

                            <Table.Row>
                              <Table.Cell className="engine-log-view-table-header-cell">Time Limit (ms)</Table.Cell>
                              <Table.Cell className="engine-log-view-table-input-wrapper">
                                {!!this.state.input && !!this.state.input.search_options && (
                                  <input
                                    type="text"
                                    name="time_limit_ms"
                                    onChange={this.engineInputCoefficientHandler}
                                    className="engine-log-view-input-text-cell"
                                    value={this.state.input.search_options.time_limit_ms}
                                  />
                                )}
                              </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell className="engine-log-view-table-header-cell">
                                Balance Tech Shift Utilization
                              </Table.Cell>
                              <Table.Cell className="engine-log-view-table-input-wrapper">
                                {!!this.state.input && !!this.state.input.search_options && (
                                  <input
                                    onChange={this.engineInputCoefficientHandler}
                                    name="balance_tech_shift_utilization"
                                    type="checkbox"
                                    checked={this.state.input.search_options.balance_tech_shift_utilization || false}
                                  />
                                )}
                              </Table.Cell>
                            </Table.Row>
                            {/* <Table.Row>
                              <Table.Cell className="engine-log-view-table-header-cell">
                                Balance Tech Time coefficient
                              </Table.Cell>
                              <Table.Cell className="engine-log-view-table-input-wrapper">
                                {!!this.state.input && !!this.state.input.search_options && (
                                  <input
                                    type="number"
                                    name="balance_tech_time_coefficient"
                                    onChange={this.engineInputCoefficientHandler}
                                    className="engine-log-view-input-text-cell"
                                    value={
                                      this.state.input.search_options.balance_tech_time_coefficient === undefined
                                        ? 0
                                        : this.state.input.search_options.balance_tech_time_coefficient
                                    }
                                  />
                                )}
                              </Table.Cell>
                            </Table.Row> */}
                            <Table.Row>
                              <Table.Cell className="engine-log-view-table-header-cell">
                                High score multiplier
                              </Table.Cell>
                              <Table.Cell className="engine-log-view-table-input-wrapper">
                                {!!this.state.input && !!this.state.input.search_options && (
                                  <input
                                    type="number"
                                    name="high_score_multiplier"
                                    onChange={this.engineInputCoefficientHandler}
                                    className="engine-log-view-input-text-cell"
                                    value={this.state.input.search_options.high_score_multiplier}
                                  />
                                )}
                              </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell className="engine-log-view-table-header-cell">Time Buffer</Table.Cell>
                              <Table.Cell className="engine-log-view-table-input-wrapper">
                                {!!this.state.input && !!this.state.input.search_options && (
                                  <input
                                    type="number"
                                    name="same_start_time_buffer"
                                    onChange={this.engineInputCoefficientHandler}
                                    className="engine-log-view-input-text-cell"
                                    value={this.state.input.search_options.same_start_time_buffer}
                                  />
                                )}
                              </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell className="engine-log-view-table-header-cell">Enable Clustering</Table.Cell>
                              <Table.Cell>
                                {!!this.state.input && !!this.state.input.search_options && (
                                  <input
                                    onChange={this.engineInputCoefficientHandler}
                                    name="enable_clustering"
                                    type="checkbox"
                                    checked={this.state.input.search_options.enable_clustering || false}
                                  />
                                )}
                              </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell className="engine-log-view-table-header-cell">
                                Enable Group Clustering
                              </Table.Cell>
                              <Table.Cell>
                                {!!this.state.input && !!this.state.input.search_options && (
                                  <input
                                    onChange={this.engineInputCoefficientHandler}
                                    name="enable_group_clustering"
                                    type="checkbox"
                                    checked={this.state.input.search_options.enable_group_clustering || false}
                                  />
                                )}
                              </Table.Cell>
                            </Table.Row>

                            <Table.Row>
                              <Table.Cell className="engine-log-view-table-header-cell">
                                Disable Tech End Location
                              </Table.Cell>
                              <Table.Cell>
                                {!!this.state.input && !!this.state.input.search_options && (
                                  <input
                                    onChange={this.engineInputCoefficientHandler}
                                    name="disable_tech_end_location"
                                    type="checkbox"
                                    checked={this.state.input.search_options.disable_tech_end_location || false}
                                  />
                                )}
                              </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell className="engine-log-view-table-header-cell">
                                Enable Crow Fly Distances
                              </Table.Cell>
                              <Table.Cell>
                                {!!this.state.input && !!this.state.input.search_options && (
                                  <input
                                    onChange={this.engineInputCoefficientHandler}
                                    name="enable_crow_fly"
                                    type="checkbox"
                                    checked={this.state.input.search_options.enable_crow_fly || false}
                                  />
                                )}
                              </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell className="engine-log-view-table-header-cell">
                                Disable Hard Assignments
                              </Table.Cell>
                              <Table.Cell>
                                {!!this.state.input && !!this.state.input.search_options && (
                                  <input
                                    onChange={this.engineInputCoefficientHandler}
                                    name="disable_hard_assignments"
                                    type="checkbox"
                                    checked={this.state.input.search_options.disable_hard_assignments || false}
                                  />
                                )}
                              </Table.Cell>
                            </Table.Row>
                          </Table.Body>
                        </Table>
                      </form>
                    </Grid.Column>
                    {/* <div> */}
                    {/* {!!this.state.input && !!this.state.input.search_options && (
                <pre>{JSON.stringify(this.state.input.search_options, null, 4)}</pre>
                )} */}
                    {/* </div> */}
                    <Grid.Column style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <button
                        id="engine-log-view-rerun-button"
                        className="ui button"
                        onClick={this.handleEngineRerunClick}
                      >
                        Rerun Engine
                      </button>
                    </Grid.Column>
                  </Grid.Row>
                  {/* seperator https://{s}.tile.osm.org/{z}/{x}/{y}.png */}
                  <Grid.Row columns={4}>
                    <Grid.Column width={4}>
                      <Dropdown
                        id="engine-log-view-filter-users"
                        placeholder="Filter users on Map"
                        fluid
                        multiple
                        search
                        selection
                        options={this.state.users}
                        value={this.state.selectedUsers || []}
                        onChange={this.handleFilterUser}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Dropdown
                        id="engine-log-view-filter-users"
                        placeholder="Filter users by team on Map"
                        fluid
                        multiple
                        search
                        selection
                        options={this.state.teamsUtilizedOptions}
                        value={this.state.selectedTeams || []}
                        onChange={this.handleFilterTeam}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <MapContainer
                        style={{ padding: '50px', height: '600px', width: '100%' }}
                        scrollWheelZoom={false}
                        bounds={this.state.bounds}
                        boundsOptions={{ padding: [50, 50] }}
                      >
                        {!!this.state.mapInput &&
                          !!this.state.mapInput.length &&
                          this.state.mapInput.map((stop) => {
                            // let icon = L.divIcon({
                            //   className: "redcolor",
                            //   html:
                            //     '<i style="font-weight:bold;color:red">' +
                            //     stop.name +
                            //     "</i>"
                            // });
                            let markerColor = '#cb7119';
                            if (!!this.state.startEndLocsDict && stop.id && this.state.startEndLocsDict[stop.id]) {
                              markerColor = 'aqua';
                            }
                            // let hasHighScore =  false;
                            if (
                              stop.tasks &&
                              this.state.input &&
                              this.state.input.search_options &&
                              !_.isNil(this.state.input.search_options.high_score_threshold)
                            ) {
                              if (
                                stop.tasks.filter(
                                  (e) => e.score >= this.state.input.search_options.high_score_threshold
                                ).length > 0
                              ) {
                                // hasHighScore = true
                                markerColor = 'red';
                              }
                            }
                            const tasksCount = stop.tasks ? stop.tasks.length : 0;
                            return (
                              <CircleMarker
                                key={stop.id}
                                center={stop.latLng || this.state.center}
                                radius={7}
                                color={markerColor}
                              >
                                <Popup>
                                  <span>
                                    {`Stop Name: ${stop.name}`} <br />
                                    <div>{`Tasks: ${tasksCount}`}</div>
                                    <br />
                                    {!!stop.tasks &&
                                      stop.tasks.length > 0 &&
                                      stop.tasks.map((e) => {
                                        return (
                                          <div
                                            style={{
                                              color: e.engine_assigned ? 'black' : 'red',
                                            }}
                                            key={e.id}
                                          >
                                            {`${e['tasks:name']}  - Score: ${e.score}  - ServiceTime: ${Math.round(
                                              e.service_time / 60
                                            )}`}{' '}
                                            <br />
                                          </div>
                                        );
                                      })}
                                  </span>
                                </Popup>
                              </CircleMarker>
                            );
                          })}
                        {!!this.state.newmapOutput &&
                          !!this.state.newmapOutput.length &&
                          this.state.newmapOutput.map((line, i) => {
                            // let icon = L.divIcon({
                            //   className: "redcolor",
                            //   html:
                            //     '<i style="font-weight:bold;color:red">' +
                            //     stop.name +
                            //     "</i>"
                            // });

                            const arrow = [
                              {
                                offset: 0,
                                repeat: 200,
                                color: line.color,
                                symbol: L.Symbol.arrowHead({
                                  color: line.color,
                                  pixelSize: 5,
                                  polygon: false,
                                  pathOptions: { stroke: true },
                                }),
                              },
                            ];
                            return (
                              <PolylineDecorator
                                key={line.techObject.id}
                                color={line.color}
                                patterns={arrow}
                                positions={line.visitsLatLng}
                              >
                                <Popup>
                                  <span>
                                    {`Tech Name: ${line.techObject['techs:name']}`} <br />
                                    {!!line.currentRoute &&
                                      line.currentRoute.map((e, i) => {
                                        let { task_name } = e;
                                        let service_time = Math.round(e.service_time / 60);
                                        let { score } = e;
                                        if (e.task_name === ' ') {
                                          task_name = 'START';
                                          service_time = '';
                                        }
                                        if (e.task_name === 'Totals') {
                                          task_name = 'END';
                                          service_time = '';
                                          score = '';
                                        }
                                        return (
                                          <div key={task_name}>
                                            <b>{i}</b>
                                            {` : ${task_name} - ${score} - ${service_time} - ${e.location_name}`} <br />
                                          </div>
                                        );
                                      })}
                                  </span>
                                </Popup>
                              </PolylineDecorator>
                              // <Polyline positions={line.visitsLatLng} color={markerColor}>

                              // </Polyline>
                            );
                          })}
                        {/* <TileLayer
                attribution='Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012'
                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
                /> */}
                        <TileLayer
                          attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
                          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                        />
                      </MapContainer>
                    </Grid.Column>
                  </Grid.Row>
                  {/* seperator */}
                  <Grid.Row>
                    <Grid.Column>
                      <h1>Skipped Tasks Summary</h1>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      {!!this.state.skippedTasksSummary && this.state.skippedTasksSummary.length > 0 && (
                        <div className="ag-theme-balham" style={gridStyle}>
                          <AgGridReact
                            {...GRID_OPTIONS}
                            // domLayout="autoHeight"
                            columnDefs={this.getColumnDefs(Object.keys(this.state.skippedTasksSummary[0]))}
                            rowData={this.state.skippedTasksSummary}
                            colResizeDefault="shift"
                            // onRowDataChanged={(params) => {
                            //   params.api.sizeColumnsToFit();
                            // }}
                            onGridReady={(params) => {
                              this.onGridReady(params, true);
                            }}
                            statusBar={{
                              statusPanels: [
                                {
                                  statusPanel: 'agTotalAndFilteredRowCountComponent',
                                  align: 'left',
                                },
                              ],
                            }}
                          />
                        </div>
                      )}
                    </Grid.Column>
                  </Grid.Row>
                  {/* seperator */}
                  <Grid.Row>
                    <Grid.Column>
                      <h1>Engine Results - Task Types Summary</h1>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      {!!this.state.taskTypesRoutesSummary && this.state.taskTypesRoutesSummary.length > 0 && (
                        <div className="ag-theme-balham" style={gridStyle}>
                          <AgGridReact
                            {...GRID_OPTIONS}
                            // domLayout="autoHeight"
                            enableRowGroup={true}
                            columnDefs={this.getColumnDefs(
                              Object.keys(this.state.taskTypesRoutesSummary[0]),
                              'task_type_name'
                            )}
                            rowData={this.state.taskTypesRoutesSummary}
                            colResizeDefault="shift"
                            // onRowDataChanged={(params) => {
                            //   params.api.sizeColumnsToFit();
                            // }}
                            onGridReady={(params) => {
                              this.onGridReady(params, true);
                            }}
                            statusBar={{
                              statusPanels: [
                                {
                                  statusPanel: 'agTotalAndFilteredRowCountComponent',
                                  align: 'left',
                                },
                              ],
                            }}
                            autoGroupColumnDef={this.state.autoGroupColumnDef}
                            getRowStyle={this.getRowStyle}
                          />
                        </div>
                      )}
                    </Grid.Column>
                  </Grid.Row>
                  {/* seperator */}
                  <Grid.Row>
                    <Grid.Column>
                      <h1>Engine Results - Users Summary</h1>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      {!!this.state.techRoutesSummary && this.state.techRoutesSummary.length > 0 && (
                        <div className="ag-theme-balham" style={gridStyle}>
                          <AgGridReact
                            {...GRID_OPTIONS}
                            // domLayout="autoHeight"
                            enableRowGroup={true}
                            columnDefs={this.getColumnDefs(Object.keys(this.state.techRoutesSummary[0]), 'tech_name')}
                            rowData={this.state.techRoutesSummary}
                            colResizeDefault="shift"
                            // onRowDataChanged={(params) => {
                            //   params.api.sizeColumnsToFit();
                            // }}
                            onGridReady={(params) => {
                              this.onGridReady(params, true);
                            }}
                            statusBar={{
                              statusPanels: [
                                {
                                  statusPanel: 'agTotalAndFilteredRowCountComponent',
                                  align: 'left',
                                },
                              ],
                            }}
                            getRowStyle={this.getRowStyle}
                            autoGroupColumnDef={this.state.autoGroupColumnDef}
                          />
                        </div>
                      )}
                    </Grid.Column>
                  </Grid.Row>
                  {/* seperator */}
                  <Grid.Row>
                    <Grid.Column>
                      <h1>Engine Results - Stops Summary</h1>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      {!!this.state.stopsDetailedSummary && this.state.stopsDetailedSummary.length > 0 && (
                        <div className="ag-theme-balham" style={gridStyle}>
                          <AgGridReact
                            {...GRID_OPTIONS}
                            // domLayout="autoHeight"
                            enableRowGroup={true}
                            columnDefs={this.getColumnDefs(
                              Object.keys(this.state.stopsDetailedSummary[0]),
                              'stop_name'
                            )}
                            rowData={this.state.stopsDetailedSummary}
                            colResizeDefault="shift"
                            autoGroupColumnDef={this.state.autoGroupColumnDef}
                            // onRowDataChanged={(params) => {
                            //   params.api.sizeColumnsToFit();
                            // }}
                            onGridReady={(params) => {
                              this.onGridReady(params, true);
                            }}
                            statusBar={{
                              statusPanels: [
                                {
                                  statusPanel: 'agTotalAndFilteredRowCountComponent',
                                  align: 'left',
                                },
                              ],
                            }}
                            getRowStyle={this.getRowStyle}
                          />
                        </div>
                      )}
                    </Grid.Column>
                  </Grid.Row>
                  {/* seperator */}
                  <Grid.Row>
                    <Grid.Column>
                      <h1>Detailed Switch</h1>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      {!!this.state.routes && this.state.routes.length && (
                        <div className="ag-theme-balham" style={gridStyle}>
                          <AgGridReact
                            {...GRID_OPTIONS}
                            // domLayout="autoHeight"
                            enableRowGroup
                            columnDefs={this.getColumnDefs(Object.keys(this.state.routes[0]), 'tech_name')}
                            rowData={this.state.routes}
                            colResizeDefault="shift"
                            // onRowDataChanged={(params) => {
                            //   params.api.sizeColumnsToFit();
                            // }}
                            onGridReady={(params) => {
                              this.onGridReady(params, true);
                            }}
                            statusBar={{
                              statusPanels: [
                                {
                                  statusPanel: 'agTotalAndFilteredRowCountComponent',
                                  align: 'left',
                                },
                              ],
                            }}
                            autoGroupColumnDef={this.state.autoGroupColumnDef}
                          />
                        </div>
                      )}
                    </Grid.Column>
                  </Grid.Row>
                  {/* seperator */}
                  <Grid.Row>
                    <Grid.Column>
                      <h1>Tasks</h1>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      {!!this.state.tasks && this.state.tasks.length > 0 && (
                        <div>
                          <div className="ag-theme-balham" style={gridStyle}>
                            <AgGridReact
                              {...GRID_OPTIONS}
                              // domLayout="autoHeight"
                              columnDefs={this.getColumnDefs(Object.keys(this.state.tasks[0]))}
                              rowData={this.state.tasks}
                              colResizeDefault="shift"
                              // onRowDataChanged={(params) => {
                              //   params.api.sizeColumnsToFit();
                              // }}
                              onGridReady={(params) => {
                                this.onGridReady(params, true);
                              }}
                              statusBar={{
                                statusPanels: [
                                  {
                                    statusPanel: 'agTotalAndFilteredRowCountComponent',
                                    align: 'left',
                                  },
                                ],
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </Grid.Column>
                  </Grid.Row>

                  {/* seperator */}
                  <Grid.Row>
                    <Grid.Column className="column is-three-quarters">
                      <h1>Techs</h1>
                    </Grid.Column>
                    <div className="column is-one-quarters">{/* <h1>Task Types</h1> */}</div>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      {!!this.state.input && !!this.state.input.techs && (
                        <div className="ag-theme-balham" style={gridStyle}>
                          <AgGridReact
                            {...GRID_OPTIONS}
                            // domLayout="autoHeight"
                            columnDefs={this.getColumnDefs(Object.keys(this.state.input.techs[0]))}
                            rowData={this.state.input.techs}
                            colResizeDefault="shift"
                            // onRowDataChanged={(params) => {
                            //   params.api.sizeColumnsToFit();
                            // }}
                            onGridReady={(params) => {
                              this.onGridReady(params, true);
                            }}
                            statusBar={{
                              statusPanels: [
                                {
                                  statusPanel: 'agTotalAndFilteredRowCountComponent',
                                  align: 'left',
                                },
                              ],
                            }}
                          />
                        </div>
                      )}
                    </Grid.Column>
                  </Grid.Row>
                  {/* seperator */}
                  <Grid.Row>
                    <Grid.Column>
                      <h1>Team Areas</h1>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      {!!this.state.teams && this.state.teams.length > 0 && (
                        <div className="ag-theme-balham" style={gridStyle}>
                          <AgGridReact
                            {...GRID_OPTIONS}
                            // domLayout="autoHeight"
                            enableRowGroup
                            columnDefs={this.getColumnDefs(Object.keys(this.state.teams[0]), 'area_name')}
                            rowData={this.state.teams}
                            colResizeDefault="shift"
                            // onRowDataChanged={(params) => {
                            //   params.api.sizeColumnsToFit();
                            // }}
                            onGridReady={(params) => {
                              this.onGridReady(params, true);
                            }}
                            statusBar={{
                              statusPanels: [
                                {
                                  statusPanel: 'agTotalAndFilteredRowCountComponent',
                                  align: 'left',
                                },
                              ],
                            }}
                            autoGroupColumnDef={this.state.autoGroupColumnDef}
                          />
                        </div>
                      )}
                    </Grid.Column>
                  </Grid.Row>
                  {/* seperator */}
                  <Grid.Row>
                    <Grid.Column>
                      <h1>Duration Matrix</h1>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      {!!this.state.input &&
                        !!this.state.input.distance_matrix &&
                        !!this.state.input.distanceMatrix && (
                          <div className="ag-theme-balham" style={gridStyle}>
                            <AgGridReact
                              {...GRID_OPTIONS}
                              // domLayout="autoHeight"
                              columnDefs={this.getColumnDefs(
                                Object.keys(this.state.input.distanceMatrix[0]),
                                undefined,
                                true
                              )}
                              rowData={this.state.input.distanceMatrix}
                              colResizeDefault="shift"
                              // onRowDataChanged={(params) => {
                              //   params.api.sizeColumnsToFit();
                              // }}
                              onGridReady={(params) => {
                                this.onGridReady(params, false);
                              }}
                              statusBar={{
                                statusPanels: [
                                  {
                                    statusPanel: 'agTotalAndFilteredRowCountComponent',
                                    align: 'left',
                                  },
                                ],
                              }}
                            />
                          </div>
                        )}
                    </Grid.Column>
                  </Grid.Row>
                  {/* seperator */}
                  <Grid.Row>
                    <Grid.Column>
                      <h1>Task Types</h1>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column className="column is-one-thirds">
                      {!!this.state.input &&
                        !!this.state.input.task_types &&
                        this.state.input.task_types.length > 0 && (
                          <div className="ag-theme-balham" style={gridStyle}>
                            <AgGridReact
                              {...GRID_OPTIONS}
                              // domLayout="autoHeight"
                              columnDefs={this.getColumnDefs(Object.keys(this.state.input.task_types[0]))}
                              rowData={this.state.input.task_types}
                              colResizeDefault="shift"
                              // onRowDataChanged={(params) => {
                              //   params.api.sizeColumnsToFit();
                              // }}
                              onGridReady={(params) => {
                                this.onGridReady(params, true);
                              }}
                              statusBar={{
                                statusPanels: [
                                  {
                                    statusPanel: 'agTotalAndFilteredRowCountComponent',
                                    align: 'left',
                                  },
                                ],
                              }}
                            />
                          </div>
                        )}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default EngineSingleLogView;
